import { render } from "./GoogleSheets.vue?vue&type=template&id=72e7f59d"
import script from "./GoogleSheets.vue?vue&type=script&lang=js"
export * from "./GoogleSheets.vue?vue&type=script&lang=js"

import "./GoogleSheets.vue?vue&type=style&index=0&id=72e7f59d&lang=scss"
script.render = render

export default script